import scrollDirective from "@/components/directives/ScrollDirective";
import focusDirective from '@/components/directives/FocusDirective';
function activateGlobalDirectives() {
    scrollDirective();
    focusDirective();
}
export default activateGlobalDirectives;



//////////////////
// WEBPACK FOOTER
// ./src/components/directives/GlobalDirectives.ts
// module id = IAIE
// module chunks = 18